import React from "react";
import ApiKeysTab from "@/components/settings/ApiKeysTab";
import { useTranslation } from "react-i18next";

// Página "secreta": acessível apenas por URL direta (não aparece em nenhum menu).
const ApiKeys: React.FC = () => {
  const { t } = useTranslation("notifications");

  return (
    <div className="w-full flex flex-col gap-10">
      <h2 className="text-[26px] mb-[10px] sm:text-[30px] font-semibold text-neutral-50">
        {t("apiKeysTitle")}
      </h2>
      <div className="p-6 border border-[#3F3F464D] rounded-[8px]">
        <ApiKeysTab />
      </div>
    </div>
  );
};

export default ApiKeys;
